import { render, staticRenderFns } from "./TextareaMenuBarIcon.vue?vue&type=template&id=71a90c7f&scoped=true"
import script from "./TextareaMenuBarIcon.vue?vue&type=script&lang=js"
export * from "./TextareaMenuBarIcon.vue?vue&type=script&lang=js"
import style0 from "./TextareaMenuBarIcon.vue?vue&type=style&index=0&id=71a90c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a90c7f",
  null
  
)

export default component.exports